var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contextualise"},[_c('div',{staticClass:"contextualise-wrapper"},[_c('div',{staticClass:"contextualise-text"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('p',{staticClass:"is-size-7 has-text-grey"},[_vm._t("desc")],2)]),_c('div',{staticClass:"contextualise-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }